import {
  CAMERA_PRESENTER,
  SOURCE_ROLE_SPEAKER,
  SOURCE_ROLE_HOST,
} from '@shoflo/polymer';

export function getSpeakerSources(sources) {
  return sources.filter(
    (source) =>
      source.role === SOURCE_ROLE_SPEAKER &&
      'user' in source &&
      source.type === CAMERA_PRESENTER
  );
}

export function getHostSources(sources) {
  return sources.filter(
    (source) =>
      source.role === SOURCE_ROLE_HOST &&
      'user' in source &&
      source.type === CAMERA_PRESENTER
  );
}
